import Vue from 'vue'
import GridLayout from './GridLayout.vue'
import GridWidget from './GridWidget.vue'
import GridWidgetMenu from './GridWidgetMenu.vue'

export default {
  install () {
    Vue.component(GridLayout.name, GridLayout)
    Vue.component(GridWidget.name, GridWidget)
    Vue.component(GridWidgetMenu.name, GridWidgetMenu)
  }
}
